angular.module('picmonicng').directive('plsPathway', [
  function () {
    return {
      restrict: 'E',
      scope: {
        pathway: '=',
        subpathways: '=',
        market: '=',
        loadingSubpathways: '=',
        scrollToType: '=',
        scrollToId: '=',
      },
      templateUrl: '/templates/directives/pls-pathway.html',
      controller: [
        '$scope',
        'Pathways',
        'UserService',
        'PicmonicQueue',
        '$location',
        '$filter',
        'BrowseService',
        function ($scope, Pathways, UserService, PicmonicQueue, $location, $filter, BrowseService) {
          $scope.loadPlayAll = false;
          $scope.UserService = UserService;
          $scope.BrowseService = BrowseService;
          if (typeof $scope.subpathways == 'undefined') {
            $scope.subpathways = [];
            $scope.getTracks = function () {
              $scope.loadingSubpathways = true;
              Pathways.queryv3(
                {
                  pathway_id: $scope.pathway.pathway_id,
                  resource: 'tracks',
                },
                function (pathways) {
                  $scope.track_id = $location.search().track_id;

                  var parentPathways = $filter('orderBy')(
                    $filter('filter')(pathways, {
                      parent_id: $scope.pathway.pathway_id,
                    }),
                    'sort_order'
                  );

                  var count = 1;
                  for (var a in parentPathways) {
                    var parentPathway = parentPathways[a];
                    var parentPathwayTracks = $filter('orderBy')(parentPathway.tracks, 'sort_order');

                    for (var b in parentPathwayTracks) {
                      if (!parentPathway.suggested_flag) {
                        parentPathwayTracks[b].index = count;
                        count++;
                      }
                    }

                    var subPathways = $filter('orderBy')(
                      $filter('filter')(pathways, {
                        parent_id: parentPathway.pathway_id,
                      }),
                      'sort_order'
                    );

                    for (var c in subPathways) {
                      var subPathway = subPathways[c];
                      var subPathwayTracks = $filter('orderBy')(
                        $filter('filter')(subPathway.tracks, { hidden: 0 }),
                        'sort_order'
                      );

                      for (var d in subPathwayTracks) {
                        subPathwayTracks[d].index = count;
                        count++;
                      }
                    }
                  }
                  $scope.subpathways = pathways;
                  $scope.loadingSubpathways = false;
                }
              );
            };
            $scope.getTracks();
          }

          $scope.learn = function () {
            $scope.loadPlayAll = true;
            Pathways.query({ pathway_id: $scope.pathway.pathway_id, resource: 'picmonics' }, function (picmonics) {
              PicmonicQueue.setAndPlay(picmonics);
              send_ga('event', 'Pathway', 'Play All');
            });
          };
        },
      ],
    };
  },
]);
